export default __webpack_public_path__ + "6229922556ea524abd880d0807e0e73a.png";